import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { ServiceTypeModel } from './model';
import { serviceTypeAdapter, ServiceTypeState } from './state';

export const stateName: string = 'serviceType';

export const getError = (state: ServiceTypeState): any => state.error;

export const getIsLoading = (state: ServiceTypeState): boolean => state.isLoading;

export const selectServiceTypeState: MemoizedSelector<object, ServiceTypeState> = createFeatureSelector<ServiceTypeState>(stateName);

export const selectAll: (state: object) => ServiceTypeModel[] = serviceTypeAdapter.getSelectors(selectServiceTypeState).selectAll;

export const selectById = (id: number) =>
  createSelector(selectAll, (serviceType: ServiceTypeModel[]) => {
    return serviceType ? serviceType.find(p => p.id === id) : null;
  });

export const selectError: MemoizedSelector<object, any> = createSelector(selectServiceTypeState, getError);

export const selectIsLoading: MemoizedSelector<object, boolean> = createSelector(selectServiceTypeState, getIsLoading);
